import {createActions} from 'client/framework';

const normalActions = ['CLEAR_TOOLTIP_DATA', 'SET_TOOLTIP_DATA', 'TOGGLE_TOOLTIP'];

export default createActions(null, normalActions);
